import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';
import { PiGearSixDuotone } from 'react-icons/pi';
import { FcTreeStructure } from 'react-icons/fc';

import Node, { NodeMessage, NodeValue, Button } from 'app/admin/optimizationPipelineV2/component/pipeline/nodes/base/Node';
import { useOptimizationPipeline } from 'app/admin/optimizationPipelineV2/component/pipeline/providers/OptimizationPipelineProvider';

function format4(value) { return Number.isFinite(value) ? value.toFixed(4) : '-'; }

function getGainSeverity(gain) {
    if (!Number.isFinite(gain)) return undefined;
    if (gain > 0) return 'success';
    if (gain < 0) return 'error';
    return undefined;
}

export default function UnitOptimizerNode(props) {
    const history = useHistory();
    const { ts, optimizationPipelineDetail, optimizationPipelineDetailsLoading, optimizationPipelineDetailsLoaded, openSidebar, openPopup, getOnDemandResource, ensureOnDemandResource } = useOptimizationPipeline();

    const baseValue = optimizationPipelineDetail?.optimizer_base_value;
    const bestValue = optimizationPipelineDetail?.optimizer_best_value;
    const message = optimizationPipelineDetail?.optimizer_message;

    const optimizerData = useMemo(() => {
        const gain = Number.isFinite(baseValue) && Number.isFinite(bestValue) ? bestValue - baseValue : NaN;
        const gainPercent = Number.isFinite(baseValue) && baseValue !== 0 && Number.isFinite(gain) ? (gain / baseValue) * 100 : NaN;

        return {
            baseText: format4(baseValue),
            bestText: format4(bestValue),
            gainText: format4(gain),
            percentText: Number.isFinite(gainPercent) ? (gainPercent >= 0 ? '+' : '') + gainPercent.toFixed(2) + '%' : '-',
            gainSeverity: getGainSeverity(gain)
        };
    }, [baseValue, bestValue]);

    const unitOptimizerResource = getOnDemandResource('unitOptimizerData');
    const unitOptimizerData = unitOptimizerResource?.data;

    async function handleShow() {
        const data = unitOptimizerData || await ensureOnDemandResource('unitOptimizerData');
        if (!data?.whatIf || !data?.unitOptimizerLog || !ts) return;
        history.push('/what-if/edit/' + data.whatIf + '/O' + data.unitOptimizerLog + '&TS' + ts);
    }

    return (
        <Node ref={props.anchorRef} title='Unit Optimizer' icon={PiGearSixDuotone} fit={props.fit} loading={optimizationPipelineDetailsLoading || !optimizationPipelineDetailsLoaded}>
            <div className='w-full flex flex-col gap-8'>

                <NodeValue label='Base' value={optimizerData.baseText} />
                <NodeValue label='Best' value={optimizerData.bestText} severity={optimizerData.gainSeverity} />
                <NodeValue label='Gain' value={optimizerData.gainText} severity={optimizerData.gainSeverity} />
                <NodeValue label='Gain %' value={optimizerData.percentText} severity={optimizerData.gainSeverity} />

                {message && <NodeMessage value={message} />}

                <div className='w-full flex flex-col gap-10'>
                    <div className='w-full flex gap-10'>
                        <Button genericType='DETAILS' onClick={() => { openSidebar({ type: 'UNIT_OPTIMIZER', query: '', diffOnly: false, minWidth: 480, maxWidth: 1080 }); }} />
                        <Button genericType='HISTORY' onClick={() => { openPopup({ type: 'UNIT_OPTIMIZER_HISTORY', requestToken: Date.now(), title: 'Unit Optimizer History' }); }} />
                    </div>

                    <Button genericType='SHOW' onClick={handleShow} disabled={!ts} />
                </div>

            </div>
        </Node>
    );
}